export default {
    GET_QUIZ: "GET_QUIZ",
    GET_QUIZ_ERROR: "GET_QUIZ_ERROR",
    GET_QUIZ_SUCCESS: "GET_QUIZ_SUCCESS",
    SAVE_QUIZ: "SAVE_QUIZ",
    SAVE_QUIZ_ERROR: "SAVE_QUIZ_ERROR",
    SAVE_QUIZ_SUCCESS: "SAVE_QUIZ_SUCCESS",
    CLOSE_QUIZ: "CLOSE_QUIZ"
};